import { createFileRoute } from "@tanstack/react-router";
import { ErrorHandling } from "@/pages/3d/examples/ErrorHandling";

export const Route = createFileRoute("/demo/3d/examples/error-handling")({
  component: ErrorHandling,
});
